import { z } from 'zod';

import { ComplianceStatusSchema } from './compliance-status';
import { GuaranteedValueSchema } from './guaranteed-value';
import { WarrantyCoverageStatusSchema } from './warranty-coverage-status';

export enum KnownUnitOverviewColumn {
  FRONTEND_ID = 'frontend_id',
  COVERAGE_STATUS = 'coverage_status',
  COMPLIANCE_STATUS = 'compliance_status',
  SUGGESTED_ACTION = 'suggested_action',
  AGE_IN_YEARS = 'age_in_years',
  CYCLES_TOTAL = 'cycles_total',
  THROUGHPUT_TOTAL = 'throughput_total',
  SOH = 'soh',
  GUARANTEED_SOH = 'guaranteed_soh',
  AVG_CONTAINER_TAG = 'avg_container_tag',
  AVG_PCS_TAG = 'avg_pcs_tag',
}

export const UnitOverviewColumnSchema = z.string();

export type UnitOverviewColumn = z.infer<typeof UnitOverviewColumnSchema>;

export function isKnownUnitOverviewColumn(
  column: UnitOverviewColumn,
): column is KnownUnitOverviewColumn {
  return (Object.values(KnownUnitOverviewColumn) as string[]).includes(column);
}

export const UnitOverviewColumnConfigSchema = z.object({
  column: UnitOverviewColumnSchema,
  order: z.number(),
  title: z.string().optional(),
  tooltip: z.string().optional(),
});

export type UnitOverviewColumnConfig = z.infer<
  typeof UnitOverviewColumnConfigSchema
>;

export const UnitOverviewRowSchema = z.object({
  id: z.string(),
  frontendId: z.string().optional(),
  coverageStatus: WarrantyCoverageStatusSchema.optional(),
  complianceStatus: ComplianceStatusSchema.optional(),
  suggestedAction: z.string().optional(),
  ageInYears: z.number().optional(),
  cyclesTotal: z.number().optional(),
  throughputTotal: z.number().optional(),
  soh: z.number().optional(),
  guaranteedSOH: GuaranteedValueSchema.optional(),
  avgContainerTag: z.number().optional(),
  avgPcsTag: z.number().optional(),
});

export type UnitOverviewRow = z.infer<typeof UnitOverviewRowSchema>;
